import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';
//import * as moment from 'moment-timezone';
import { UtilService } from '../services/util.service';


@Pipe({
    name: 'MonthYearFormat',
    standalone: false
})
export class MonthYearFormatPipe implements PipeTransform {
  constructor(public appService: AppService, private utilService: UtilService){}

  transform(date: any,format?:string): any {
    return this.utilService.toTimeZoneDateFormat(date, 'monthYear');    
  }
}